import React from 'react'
import YearlyTarget from '../AdminUsers/YearlyTarget'

const YearlyTargetReport = () => {
    return (
        <YearlyTarget title="District Yearly Target Report" showAction={false} addYearlyTargetPermission={false}></YearlyTarget>
    )
}

export default YearlyTargetReport